import {
  createMuiTheme,
  unstable_createMuiStrictModeTheme,
} from "@material-ui/core";

const createTheme =
  process.env.NODE_ENV === "development"
    ? unstable_createMuiStrictModeTheme
    : createMuiTheme;

const base = createMuiTheme({});

const theme = createTheme({
  breakpoints: {
    values: {
      xs: 0,
      sm: 600,
      md: 960,
      lg: 1280,
      xl: 1366,
    },
  },
  palette: {
    primary: {
      main: "#0f7dca",
      dark: "#005c9e",
    },
  },
  overrides: {
    MuiFormControlLabel: {
      root: {
        alignItems: "flex-start",
        marginLeft: "-9px",
      },
      label: {
        padding: base.spacing("8px", 0),
        fontSize: base.typography.caption.fontSize,
      },
    },
    MuiFormHelperText: {
      root: {
        marginTop: 0,
        textTransform: "uppercase",
      },
    },
    MuiInput: {
      root: {
        borderStyle: "solid",
        borderWidth: "1px",
        borderColor: base.palette.grey[300],
        "&$error": {
          borderColor: base.palette.error.main,
        },
        "&$disabled": {
          borderStyle: "dotted",
        },
        "&$focused": {
          borderColor: base.palette.grey[500],
        },
      },
      input: {
        paddingLeft: "6px",
        paddingRight: "6px",
        fontSize: base.typography.caption.fontSize,
        height: "19px",
        lineHeight: "19px",
      },
    },
    MuiInputAdornment: {
      positionEnd: {
        marginLeft: 0,
        marginRight: "6px",
      },
      positionStart: {
        marginLeft: "6px",
        marginRight: 0,
      },
    },
    MuiCheckbox: {
      root: {
        padding: "7px",
      },
    },
    MuiRadio: {
      root: {
        padding: "7px",
      },
    },
    MuiStepper: {
      root: {
        backgroundColor: "unset",
        paddingLeft: base.spacing(0),
        paddingRight: base.spacing(0),
      },
    },
    MuiStep: {
      horizontal: {
        "&&:first-child": {
          paddingLeft: base.spacing(0),
        },
        "&&:last-child": {
          paddingRight: base.spacing(0),
        },
      },
    },
    MuiStepIcon: {
      text: {
        // fontSize: base.typography.body2.fontSize,
        // fontWeight: base.typography.fontWeightMedium,
      },
    },
    MuiStepLabel: {
      label: {
        fontSize: base.typography.caption.fontSize,
      },
    },
    // @ts-ignore // Overrides typing are not included for labs components
    MuiPagination: {
      ul: {
        flexWrap: "nowrap",
      },
    },
    MuiDialogActions: {
      root: {
        paddingTop: base.spacing(2),
        paddingRight: base.spacing(3),
        paddingBottom: base.spacing(2),
        paddingLeft: base.spacing(3),
      },
      spacing: {
        "&& > :not(:first-child)": {
          marginLeft: base.spacing(2),
        },
      },
    },
    // Table
    MuiTableContainer: {
      root: {
        boxSizing: "border-box",
        borderWidth: 1,
        borderColor: base.palette.divider,
      },
    },
    MuiTableCell: {
      head: {
        backgroundColor: "#54575a",
        color: base.palette.getContrastText("#54575a"),
        whiteSpace: "nowrap",
        fontSize: base.typography.caption.fontSize,
      },
      body: {
        fontSize: base.typography.caption.fontSize,
      },
      stickyHeader: {
        backgroundColor: base.palette.grey[700],
      },
    },
  },
  props: {
    MuiButton: {
      color: "primary",
      variant: "contained",
      disableElevation: true,
    },
    MuiTable: {
      size: "small",
    },
    MuiInput: {
      autoComplete: "off",
      disableUnderline: true,
    },
  },
});

export { theme };
